import * as sessionsApi from '../../api/sessions.api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchTableDetails } from './tableThunks'

export const fetchActiveSession = createAsyncThunk(
    'sessions/fetchActiveSession',
    async (tableId: number, { rejectWithValue }) => {
        try {
            return await sessionsApi.fetchActiveSession(tableId)
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

export const fetchCurrentUserActiveSessions = createAsyncThunk(
    'sessions/fetchCurrentUserActiveSessions',
    async (_, { rejectWithValue }) => {
        try {
            return await sessionsApi.fetchCurrentUserActiveSessions()
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

export const fetchSessionHistory = createAsyncThunk(
    'sessions/fetchSessionHistory',
    async (
        { page = 0, size = 20 }: { page?: number; size?: number },
        { rejectWithValue }
    ) => {
        try {
            return await sessionsApi.fetchSessionHistory({ page, size })
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)

export const addPlayerToSession = createAsyncThunk(
    'sessions/addPlayerToSession',
    async (
        { tableId, player }: {
            tableId: number
            player: { userId?: number; guestName?: string }
        },
        { dispatch, rejectWithValue }
    ) => {
        try {
            await sessionsApi.addPlayerToSession(tableId, player)
            await dispatch(fetchTableDetails(tableId))
            return tableId
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to add player'
            )
        }
    }
)

export const markPlayerLeft = createAsyncThunk(
    'sessions/markPlayerLeft',
    async (
        { tableId, assignmentId }: { tableId: number; assignmentId: number },
        { dispatch, rejectWithValue }
    ) => {
        try {
            await sessionsApi.markPlayerLeft(tableId, assignmentId)
            await dispatch(fetchTableDetails(tableId))
            return tableId
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || error.message || 'Failed to mark player as left'
            )
        }
    }
)

export const finishSet = createAsyncThunk(
    'sessions/finishSet',
    async (
        { tableId, payerAssignmentIds }: {
            tableId: number
            payerAssignmentIds: number[]
        },
        { dispatch, rejectWithValue }
    ) => {
        try {
            await sessionsApi.finishSet(tableId, payerAssignmentIds)
            await dispatch(fetchActiveSession(tableId))
            return tableId
        } catch (error: any) {
            return rejectWithValue(error.message)
        }
    }
)